module.exports = __webpack_public_path__ + "img/002.88ce9b46.png";